import * as type from 'constants/action_types'
import { RESET_SUPPLIER_GROUP } from 'constants/action_types/supplier_group'

export const initialState = {
  createSupplierGroupModal: {
    isLoading: false,
    completed: false
  },
  deleteSupplierGroup: {
    isLoading: false,
    completed: false
  },
  removeSupplierFromGroup: {
    isLoading: false,
    completed: false
  },
  changeSupplierGroup: {
    isLoading: false,
    completed: false
  },
  updateSupplierContactInfoModal: {
    isLoading: false,
    completed: false
  },
  createSupplierGroupDropdown: {
    isLoading: false,
    completed: false
  },
  activeGroup: {
    name: '',
    suppliers: []
  },
  activeSupplier: {
    name: ''
  },
  supplierGroups: [],
  activeTab: null,
  filterTerm: '',
  sortedTableColumn: {
    direction: '',
    column: ''
  },
  suppliers: [],
  expandedSupplierIds: [],
  getSuppliers: {
    isLoading: false,
    completed: false
  }
}

function supplierGroup(state = initialState, action) {
  switch (action.type) {
    case type.SET_SUPPLIER_GROUPS_DATA:
      return {
        ...state,
        [action.payload.prop]: action.payload.value
      }
    case type.PENDING_SUPPLIER_GROUP_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: true
        }
      }
    case type.COMPLETED_SUPPLIER_GROUP_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: false,
          completed: true
        }
      }
    case type.RESET_SUPPLIER_GROUP_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: false,
          completed: false
        }
      }
    case type.SUPPLIER_GROUP_ATTRIBUTE_CHANGE:
      return {
        ...state,
        activeGroup: {
          ...state.activeGroup,
          [action.payload.prop]: action.payload.value
        }
      }
    case type.SUPPLIER_CONTACT_INFO_CHANGE:
      return {
        ...state,
        activeSupplier: {
          ...state.activeSupplier,
          [action.payload.prop]: action.payload.value
        }
      }
    case type.RESET_SUPPLIER_GROUP_DATA:
      return {
        ...state,
        [action.payload]: initialState[action.payload]
      }
    case type.SET_ACTIVE_TAB_FOR_SUPPLIER_GROUPS:
      return {
        ...state,
        activeTab: action.payload
      }
    case type.SORT_SUPPLIER_GROUP_TABLE_COLUMN:
      return {
        ...state,
        sortedTableColumn: {
          ...state.sortedTableColumn,
          column: action.payload.column,
          direction: action.payload.direction
        }
      }
    case type.UPDATE_SINGLE_SUPPLIER_DATA:
      return {
        ...state,
        suppliers: state.suppliers.map(supplier => {
          if (supplier.id === action.payload.id) {
            return {
              ...supplier,
              ...action.payload
            }
          }
          return supplier
        })
      }

    case type.UPDATE_SINGLE_SUPPLIER_GROUP_DATA: {
      const { id } = action.payload
      return {
        ...state,
        suppliers: state.suppliers.map(supplier => {
          if (supplier.supplier_group_map.id === id) {
            return {
              ...supplier,
              supplier_group_map: {
                ...supplier.supplier_group_map,
                ...action.payload,
                favorite_quote_id: action.payload.favorite_quote_id
              }
            }
          }
          return supplier
        })
      }
    }
    case RESET_SUPPLIER_GROUP:
      return {
        ...initialState
      }
    default:
      return state
  }
}

export default supplierGroup
